export const normalizeFullname = name => name.replace(/\b([a-zA-ZÀ-Úà-ú]{1}[a-zA-Zà-úÀ-Ú]{2,})\b/g, (match, p1) => `${p1.slice(0, 1).toUpperCase()}${p1.slice(1).toLowerCase()}`)

export const normalizePhoneBRA = (value) => {
  if (!value) {
    return value
  }
  const onlyNums = value.replace(/[^\d]/g, '')
  if (onlyNums.length <= 2) {
    return onlyNums
  }
  if (onlyNums.length < 6 && onlyNums.length > 2) {
    return '(' + onlyNums.slice(0, 2) + ') ' + onlyNums.slice(2)
  }
  return '(' + onlyNums.slice(0, 2) + ') ' + onlyNums.slice(2, 7) + '-' + onlyNums.slice(7)
}

export const normalizePhonePAR = (value) => {
  if (!value) {
    return value
  }
  const onlyNums = value.replace(/[^\d]/g, '')
  return `${onlyNums}`
}

export const normalizeTaxPayer = (value) => {
  if (!value) {
    return value
  }
  const onlyNums = value.replace(/[^\d]/g, '')
  if (onlyNums.length <= 3) {
    return onlyNums.slice(0, 3) + '.'
  }
  if (onlyNums.length <= 6) {
    return onlyNums.slice(0, 3) + '.' + onlyNums.slice(3, 6) + '.'
  }
  if (onlyNums.length <= 9) {
    return onlyNums.slice(0, 3) + '.' + onlyNums.slice(3, 6) + '.' + onlyNums.slice(6, 9) + '-'
  } else {
    return onlyNums.slice(0, 3) + '.' + onlyNums.slice(3, 6) + '.' + onlyNums.slice(6, 9) + '-' + onlyNums.slice(9)
  }
}
